import * as Api from '@/helpers/restApi'

export default {
  state: {
    ShowTagsEditor: false,
    ShowAddTagsEditor: false,
    ShowChangeTagsEditor: false,
    AddTagsData: [],
    TagsData: [],
    TagsDataFilter: [],
    TagsObj: {},
    ChangeTagsObj: {},
    SelectedTags: [],
    ShowSelectedTags: null
  },
  getters: {
    getShowTagsEditor: state => state.ShowTagsEditor,
    getShowAddTagsEditor: state => state.ShowAddTagsEditor,
    getShowChangeTagsEditor: state => state.ShowChangeTagsEditor,
    getTagsData: state => state.TagsData,
    getAddTagsData: state => state.AddTagsData,
    getTagsDataFilter: state => state.TagsDataFilter,
    getTagsObj: state => state.TagsObj,
    getChangeTagsObj: state => state.ChangeTagsObj,
    getSelectedTags: state => state.SelectedTags,
    getShowSelectedTags: state => state.ShowSelectedTags
  },
  mutations: {
    SetShowTagsEditor (state, val) {
      state.ShowTagsEditor = val
    },
    SetShowAddTagsEditor (state, val) {
      state.ShowAddTagsEditor = val
    },
    SetShowChangeTagsEditor (state, val) {
      state.ShowChangeTagsEditor = val
    },
    SetTagsList (state, val) {
      state.TagsData = val
      state.TagsDataFilter = val
    },
    SetTagsDataFilter (state, val) {
      state.TagsDataFilter = state.TagsData.map((item) => {
        return {
          ...item,
          InnerTags: item.InnerTags.filter((tag) => tag.Name.toLowerCase().includes(val.toLowerCase()))
        }
      })
    },
    SetTagsDataEducationFilter (state, val) {
      state.TagsDataFilter = state.TagsData.filter(item => {
        return item.Name.toLowerCase().includes(val.toLowerCase())
      })
    },
    SetTagsObj (state, val) {
      state.TagsObj = val
    },
    SetShowSelectedTags (state, val) {
      state.ShowSelectedTags = val
    },
    SetChangeTagsObj (state, val) {
      state.ChangeTagsObj = val
    },
    SetSelectedTags (state, val) {
      state.SelectedTags = val.id
      state.TagsDataFilter[val.indexTag].InnerTags[val.indexItem].IsActive = !state.TagsDataFilter[val.indexTag].InnerTags[val.indexItem].IsActive
    },
    SetSelectedTagsEducation (state, val) {
      state.SelectedTags = val.id
      state.TagsDataFilter[val.indexItem].IsActive = !state.TagsDataFilter[val.indexItem].IsActive
    }
  },
  actions: {
    setTagsData ({ state, dispatch, commit }) {
      Api.getApi({
        url: '/api/Products/GetAllInnerTags'
      })
        .then((data) => {
          if (data.Succeeded) {
            commit('SetTagsList', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setTagsDataServices ({ state, dispatch, commit }) {
      Api.getApi({
        url: '/api/Utilities/GetAllInnerTags'
      })
        .then((data) => {
          if (data.Succeeded) {
            commit('SetTagsList', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setTagsDataNews ({ state, dispatch, commit }) {
      Api.getApi({
        url: '/api/Articles/GetAllInnerTags '
      })
        .then((data) => {
          if (data.Succeeded) {
            commit('SetTagsList', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setTagsDataEducation ({ state, dispatch, commit }) {
      Api.getApi({
        url: '/api/Article/AllInnerTags'
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            commit('SetTagsList', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setAddTagsData ({ state, dispatch }) {
      Api.getApi({
        url: '/api/UniversalTags/Main'
      })
        .then((data) => {
          if (data.Succeeded) {
            state.AddTagsData = data.Data
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setChangeTagsData ({ state, dispatch }, obj) {
      Api.putApi({
        url: `/api/InnerTag/${obj.Id}`,
        payload: {
          Id: obj.Id,
          Name: obj.Name,
          UniversalTagId: obj.UniversalTagId
        }
      })
        .then((data) => {
          if (data.Succeeded) {
            if (obj.Category === 3) {
              dispatch('setTagsData')
            } else if (obj.Category === 2) {
              dispatch('setTagsDataNews')
            } else if (obj.Category === 4) {
              dispatch('setTagsDataServices')
            }
          } else {
            // окно с ошибкой
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setChangeTagsEducationData ({ state, dispatch }, obj) {
      Api.putApi({
        url: '/api/InnerTag/UpdateInnerTag',
        payload: {
          Id: obj.Id,
          Name: obj.Name
        }
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setTagsDataEducation')
          } else {
            // окно с ошибкой
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setUpdateInnerTags ({ state, dispatch }, val) {
      Api.putApi({
        url: '/api/Products/UpdateCacheInnerTags'
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setShowSelectedTags')
          } else {
            // окно с ошибкой
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setUpdateInnerTagsNews ({ state, dispatch }, val) {
      Api.putApi({
        url: '/api/Articles/UpdateCacheInnerTags'
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setShowSelectedTagsNews')
          } else {
            // окно с ошибкой
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setUpdateInnerTagsServices ({ state, dispatch }, val) {
      Api.putApi({
        url: '/api/Utilities/UpdateCacheInnerTags'
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setShowSelectedTagsServices')
          } else {
            // окно с ошибкой
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setUpdateInnerTagsEducation ({ state, dispatch }, val) {
      Api.putApi({
        url: '/api/Article/UpdateCacheInnerTags'
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setShowSelectedTagsEducation')
          } else {
            // окно с ошибкой
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setCheckInnerTag ({ state, dispatch }, obj) {
      Api.putApi({
        url: `/api/Products/CheckCacheInnerTag/${obj.Id}`,
        payload:
          {
            Value: obj.IsActive
          }
      })
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setCheckInnerTagNews ({ state, dispatch }, obj) {
      Api.putApi({
        url: `/api/Articles/CheckCacheInnerTag/${obj.Id}`,
        payload:
          {
            Value: obj.IsActive
          }
      })
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setCheckInnerTagServices ({ state, dispatch }, obj) {
      Api.putApi({
        url: `/api/Utilities/CheckCacheInnerTag/${obj.Id}`,
        payload:
          {
            Value: obj.IsActive
          }
      })
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setCheckInnerTagEducation ({ state, dispatch }, obj) {
      Api.putApi({
        url: `/api/Article/CheckCacheInnerTag/${obj.Id}`,
        payload:
          {
            Value: obj.IsActive
          }
      }, 'education')
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setShowSelectedTags ({ state, dispatch, commit }) {
      Api.getApi({
        url: '/api/Products/GetSelectedInnerTagsByCache'
      })
        .then((data) => {
          if (data.Succeeded) {
            commit('SetShowSelectedTags', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setShowSelectedTagsNews ({ state, dispatch, commit }) {
      Api.getApi({
        url: '/api/Articles/GetSelectedInnerTagsByCache'
      })
        .then((data) => {
          if (data.Succeeded) {
            commit('SetShowSelectedTags', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setShowSelectedTagsServices ({ state, dispatch, commit }) {
      Api.getApi({
        url: '/api/Utilities/GetSelectedInnerTagsByCache'
      })
        .then((data) => {
          if (data.Succeeded) {
            commit('SetShowSelectedTags', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setShowSelectedTagsEducation ({ state, dispatch, commit }) {
      Api.getApi({
        url: '/api/Article/GetSelectedInnerTagsByCache'
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            commit('SetShowSelectedTags', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setDeleteTag ({ dispatch }, obj) {
      Api.deleteApi({
        url: `/api/InnerTag/${obj.id}`
      })
        .then((data) => {
          if (data.Succeeded) {
            if (obj.category === 3) {
              dispatch('setTagsData')
            } else if (obj.category === 2) {
              dispatch('setTagsDataNews')
            } else if (obj.category === 4) {
              dispatch('setTagsDataServices')
            }
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setDeleteTagEducation ({ dispatch }, obj) {
      Api.deleteApi({
        url: `/api/InnerTag/DeleteInnerTag/${obj.id}`
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setTagsDataEducation')
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setPostTags ({ state, commit, dispatch }, obj) {
      return Api.postApi({
        url: '/api/InnerTag',
        payload: {
          Name: obj.Name,
          UniversalTagId: obj.UniversalTagId
        }
      })
        .then((data) => {
          if (data.Succeeded) {
            if (obj.Category === 3) {
              dispatch('setTagsData')
            } else if (obj.Category === 2) {
              dispatch('setTagsDataNews')
            } else if (obj.Category === 4) {
              dispatch('setTagsDataServices')
            }
          } else {
            // окно с ошибкой
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setPostTagsEducation ({ state, commit, dispatch }, obj) {
      return Api.postApi({
        url: '/api/InnerTag/CreateInnerTag',
        payload: {
          Name: obj.Name
        }
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setTagsDataEducation')
          } else {
            // окно с ошибкой
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setDeleteCacheInnerTag ({ dispatch }, id) {
      Api.deleteApi({
        url: `/api/Products/DeleteCacheInnerTag/${id}`
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setShowSelectedTags')
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setDeleteCacheInnerTagServices ({ dispatch }, id) {
      Api.deleteApi({
        url: `/api/Utilities/DeleteCacheInnerTag/${id}`
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setShowSelectedTagsServices')
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setDeleteCacheInnerTagNews ({ dispatch }, id) {
      Api.deleteApi({
        url: `/api/Articles/DeleteCacheInnerTag/${id}`
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setShowSelectedTagsNews')
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setDeleteCacheInnerTagEducation ({ dispatch }, id) {
      Api.deleteApi({
        url: `/api/Article/DeleteCacheInnerTag/${id}`
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setShowSelectedTagsEducation')
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setClearCacheInnerTag ({ dispatch }) {
      Api.deleteApi({
        url: '/api/Products/ClearCheckedInnerTags'
      })
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setClearCacheInnerTagNews ({ dispatch }) {
      Api.deleteApi({
        url: '/api/Articles/ClearCheckedInnerTags'
      })
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setClearCacheInnerTagServices ({ dispatch }) {
      Api.deleteApi({
        url: '/api/Utilities/ClearCheckedInnerTags'
      })
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setClearCacheInnerTagEducation ({ dispatch }) {
      Api.deleteApi({
        url: '/api/Article/ClearCheckedInnerTags'
      }, 'education')
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setClearAllTagArticle ({ dispatch }) {
      Api.deleteApi({
        url: '/api/Articles/ClearInnerTags'
      })
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          } else {
            dispatch('setShowSelectedTagsNews')
          }
        })
    },
    setClearAllTagUtilites ({ dispatch }) {
      Api.deleteApi({
        url: '/api/Utilities/ClearInnerTags'
      })
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          } else {
            dispatch('setShowSelectedTagsServices')
          }
        })
    },
    setClearAllTagProducts ({ dispatch }) {
      Api.deleteApi({
        url: '/api/Products/ClearInnerTags'
      })
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          } else {
            dispatch('setShowSelectedTags')
          }
        })
    }
  }
}
